import { AppTenants, ConsultationStatusConstant, ConsultDoctorType, DoctorTypes, ROLE_NAMES, WATCHMEN_RESOURCES } from "../constants"
import React, { ReactNode } from "react"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import SetMealOutlinedIcon from "@mui/icons-material/SetMealOutlined"
import SelfImprovementOutlinedIcon from "@mui/icons-material/SelfImprovementOutlined"
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined"
import NfcOutlinedIcon from "@mui/icons-material/NfcOutlined"
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined"
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined"
import WatchOutlinedIcon from "@mui/icons-material/WatchOutlined"
import BloodtypeOutlinedIcon from "@mui/icons-material/BloodtypeOutlined"
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined"
import FlagCircleOutlinedIcon from "@mui/icons-material/FlagCircleOutlined"
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined"
import AllInclusiveOutlinedIcon from "@mui/icons-material/AllInclusiveOutlined"
import SnippetFolderOutlinedIcon from "@mui/icons-material/SnippetFolderOutlined"
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined"
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined"
import WorkHistoryIcon from "@mui/icons-material/WorkHistory"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import ListAltIcon from "@mui/icons-material/ListAlt"
import { IAppointment } from "../interfaces/api/albus/appointment"
import { getOrionUrl } from "../utils/orionRedirectUtils"
import { FaceOutlined } from "@mui/icons-material"
import PeopleAltIcon from "@mui/icons-material/PeopleAlt"
import MenuBookIcon from "@mui/icons-material/MenuBook"
import PollRoundedIcon from "@mui/icons-material/PollRounded"
import { EventNames } from "../constants/eventNames"
import BookIcon from "@mui/icons-material/Book"
import { AiOutlineExperiment } from "react-icons/ai"
import { jsx } from "@emotion/react"
import { FaSyringe } from "react-icons/fa6"

export interface INavConfig {
	id: string
	url: string
	label: ReactNode
	featureEnabledKey?: string
	visibilityOn?: string
	children?: INavConfig[]
	resource?: WATCHMEN_RESOURCES
	icon?: ReactNode
	disabled?: boolean
	/*Extra Props*/

	showInDropdown?: boolean
	accessUsers?: DoctorTypes[]
	accessRoles?: ROLE_NAMES[]
	accessTenants?: AppTenants[]
	selectedMatchUrl?: string[]
	allowedPatientTenants?: AppTenants[]
	//@TODO: temporary field remove after full deployment
	redirectToOrion?: boolean
	eventName?: EventNames
}

export const RoutePathSeparator = "/"

export const ROUTE_NAMES = {
	HOMEPAGE: "/",
	CALENDER: "calender",
	PATIENTS: "patients",
	RESUME: "resume",
	ROSTER: "roster",
	AUTOMATED_ROSTER: "automated-roster",
	CONSULTS: "consults",
	TREATMENT_PLAN: "treatment-plans",
	MEAL_PLAN: "meal-plans",
	ODIN: "odin",
	TASK: "tasks",
	LINKS_LIBRARY: "links-library",
	CATALOGUE: "catalogue",

	PATIENT_DETAILS: "patient",
	PROFILE: "profile",
	DOCTOR_PROFILE: "doctor-profile",

	CONSULTATIONS: "consultations",
	PSYCHOLOGIST_CONSULTATIONS: "mental-health",
	CONSULTATION: "consultation",
	LIFESTYLE_RECALL: "lifestyle-recall",

	ACTIVE_PLAN: "active-plan",
	ADHERENCE: "adherence",

	CGM: "cgm",
	DAILY_ACTIVITY: "daily-activity",
	FITNESS_DATA: "fitness-data",
	GLUCOSE: "glucose",
	LAB_TEST: "lab-test",
	GLP_1_PROGRAM: "glp",
	EXPERIMENTS: "experiments",
	EXPERIMENT_DETAILS: "details/:experimentId",
	VITALS: "vitals",
	GOALS: "goals",
	DOCUMENTS: "documents",

	PATIENT_HISTORY: "history",
	PATIENT_NOTES: "notes",
	CREATE_PATIENT_NOTES: "create-notes",

	ONGOING_DOCTOR_CONSULT: "doctor-consult",
	EDIT_DOCTOR_CONSULT: "edit-doctor-consult",
	ONGOING_COACH_CONSULT: "coach-consult",
	EDIT_COACH_CONSULT: "edit-coach-consult",
	ONGOING_PSYCHOLOGIST_CONSULT: "psychologist-consult",
	EDIT_PSYCHOLOGIST_CONSULT: "edit-psychologist-consult",
	VERIFY_COACH_CONSULT: "verify-coach-consult",
	RCA: "rca",
	RCA_EDIT: "rca/:userId/edit",
	REQUESTS: "requests",
	POLLS: "polls",
	POLL_CREATE: "polls/create",
	POLL_DETAILS: "polls/details",
	CHALLENGE: "challenge",
	CHALLENGE_CREATE: "challenge/create",
	CHALLENGE_DETAILS: "challenge/details",
	METRICS: "metrics",
	CONSULT_RATING: "consult-rating",
	STATS: "stats",
	GLP_APPROVAL_QUEUE: "glp-approvals",
}

export const APP_TOP_NAVS: INavConfig[] = [
	{ id: "calendar", url: "", label: "My Planner", resource: WATCHMEN_RESOURCES.CALENDAR, eventName: EventNames.TOP_NAV__MY_PLANNER },
	{ id: "patients", url: ROUTE_NAMES.PATIENTS, label: "My Patients", resource: WATCHMEN_RESOURCES.PATIENT_LIST, eventName: EventNames.TOP_NAV__MY_PATIENTS },
	{
		id: "doctor-profile",
		url: ROUTE_NAMES.DOCTOR_PROFILE,
		label: "Profile",
		resource: WATCHMEN_RESOURCES.DOCTOR_PROFILE,
		showInDropdown: true,
		icon: <FaceOutlined />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__PROFILE,
	},
	{
		id: "roster",
		url: ROUTE_NAMES.ROSTER,
		label: "Working Hours",
		resource: WATCHMEN_RESOURCES.ROSTER,
		showInDropdown: true,
		icon: <WorkHistoryIcon />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__WORKING_HOURS,
	},
	{ id: "rca", url: ROUTE_NAMES.RCA, label: "Reports", resource: WATCHMEN_RESOURCES.RCA, eventName: EventNames.TOP_NAV__RCA },
	{
		id: "requests",
		url: ROUTE_NAMES.REQUESTS,
		label: "Requests",
		resource: WATCHMEN_RESOURCES.ROSTER,
		showInDropdown: true,
		icon: <PeopleAltIcon />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__REQUESTS,
	},
	{ id: "consults", url: ROUTE_NAMES.CONSULTS, label: "Consultations", resource: WATCHMEN_RESOURCES.DOCTOR_CONSULT_LIST, eventName: EventNames.TOP_NAV__CONSULTATIONS },
	{
		id: "glp-approvals",
		url: ROUTE_NAMES.GLP_APPROVAL_QUEUE,
		label: "GLP Approvals",
		// Page-level visibility is gated by useGlpCareTeamEnabled(); non-enrolled doctors
		// see an empty-state message instead of the queue content.
		accessUsers: [DoctorTypes.DOCTOR],
		featureEnabledKey: "glpCareTeam",
		resource: WATCHMEN_RESOURCES.DOCTOR_CONSULT_LIST,
	},
	{ id: "polls", url: ROUTE_NAMES.POLLS, label: "Polls", resource: WATCHMEN_RESOURCES.POLLS, showInDropdown: true, icon: <PollRoundedIcon /> },
	{ id: "challenges", url: ROUTE_NAMES.CHALLENGE, label: "Challenges", resource: WATCHMEN_RESOURCES.CHALLENGES },
	{
		id: "links-library",
		url: ROUTE_NAMES.LINKS_LIBRARY,
		label: "Links Library",
		resource: WATCHMEN_RESOURCES.LINKS_LIBRARY,
		icon: <MenuBookIcon />,
		showInDropdown: true,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__LINKS_LIBRARY,
	},
	// {
	// 	id: "treatmentPlans",
	// 	url: ROUTE_NAMES.TREATMENT_PLAN,
	// 	label: "Treatment Plans",
	// 	resource: WATCHMEN_RESOURCES.TREATMENT_PLAN,
	// 	icon: <MedicationLiquidIcon />,
	// },
	{
		id: "mealPlans",
		url: ROUTE_NAMES.MEAL_PLAN,
		label: "My Meal Plans",
		resource: WATCHMEN_RESOURCES.MEAL_PLAN,
		showInDropdown: true,
		icon: <RestaurantIcon />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__MY_MEAL_PLANS,
	},
	{
		id: "odin",
		url: ROUTE_NAMES.ODIN,
		label: "Odin",
		accessUsers: [DoctorTypes.LIFESTYLE_COACH, DoctorTypes.DOCTOR],
		resource: WATCHMEN_RESOURCES.ODIN,
		eventName: EventNames.TOP_NAV__ODIN,
	},
	{
		id: "myTask",
		url: ROUTE_NAMES.TASK,
		label: "My Task",
		accessUsers: [DoctorTypes.LIFESTYLE_COACH],
		resource: WATCHMEN_RESOURCES.TASK,
		showInDropdown: true,
		icon: <BookIcon />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__MY_TASKS,
	},
	{
		id: "catalogue",
		url: ROUTE_NAMES.CATALOGUE,
		label: "Catalogues",
		resource: WATCHMEN_RESOURCES.CATALOGUE,
		showInDropdown: true,
		icon: <ListAltIcon />,
		eventName: EventNames.TOP_NAV__PROFILE_DROPDOWN__MEDICINE_CATALOG,
	},
]

export const LEFT_NAV_ITEMS: INavConfig[] = [
	{
		id: "profile",
		url: "",
		label: "Profile",
		resource: WATCHMEN_RESOURCES.PATIENT_PROFILE,
		icon: <PersonOutlineIcon />,
	},
	{
		id: "consultations",
		url: ROUTE_NAMES.CONSULTATIONS,
		label: "Consultations",
		resource: WATCHMEN_RESOURCES.PATIENT_CONSULTATIONS,
		icon: <SupportAgentIcon />,
	},
	{
		id: "psychologist-consultations",
		url: ROUTE_NAMES.PSYCHOLOGIST_CONSULTATIONS,
		label: "Mental Health",
		resource: WATCHMEN_RESOURCES.PSYCHOLOGIST_CONSULTATIONS,
		icon: <SupportAgentIcon />,
	},
	{
		id: "lifestyle-recall",
		url: ROUTE_NAMES.LIFESTYLE_RECALL,
		label: "Lifestyle Recall",
		resource: WATCHMEN_RESOURCES.PATIENT_LIFESTYLE_RECALL,
		icon: <VolunteerActivismOutlinedIcon />,
	},
	{
		id: "lifestyle",
		url: "",
		label: "Lifestyle",
		disabled: true,
		icon: <SelfImprovementOutlinedIcon />,
		children: [
			{
				id: "active-plan",
				url: ROUTE_NAMES.ACTIVE_PLAN,
				label: "Active Plan",
				icon: <ArticleOutlinedIcon />,
				resource: WATCHMEN_RESOURCES.PATIENT_ACTIVE_PLAN,
			},
			{
				id: "adherence",
				url: ROUTE_NAMES.ADHERENCE,
				label: "Adherence",
				resource: WATCHMEN_RESOURCES.PATIENT_ADHERENCE,
				icon: <AllInclusiveOutlinedIcon />,
			},
		],
	},
	{
		id: "patient-data",
		url: "",
		// disabled: true,
		label: "Patient Data",
		icon: <SetMealOutlinedIcon />,
		children: [
			{
				id: "cgm",
				url: ROUTE_NAMES.CGM,
				label: "CGM",
				resource: WATCHMEN_RESOURCES.PATIENT_CGM_ACT,
				icon: <NfcOutlinedIcon />,
			},
			{
				id: "daily-activity",
				url: ROUTE_NAMES.DAILY_ACTIVITY,
				label: "Daily Activity",
				resource: WATCHMEN_RESOURCES.PATIENT_DAILY_ACT,
				icon: <DirectionsRunOutlinedIcon />,
			},
			{
				id: "fitness-data",
				url: ROUTE_NAMES.FITNESS_DATA,
				label: "Fitness Data",
				resource: WATCHMEN_RESOURCES.PATIENT_FITNESS_DATA,
				icon: <WatchOutlinedIcon />,
			},
			{
				id: "glucose",
				url: ROUTE_NAMES.GLUCOSE,
				label: "Sugar Journal",
				resource: WATCHMEN_RESOURCES.PATIENT_GLUCOSE,
				icon: <BloodtypeOutlinedIcon />,
			},
			{
				id: "experiments",
				url: ROUTE_NAMES.EXPERIMENTS,
				label: "Experiments",
				resource: WATCHMEN_RESOURCES.EXPERIMENTS,
				icon: <AiOutlineExperiment />,
			},
			{
				id: "lab-test",
				url: ROUTE_NAMES.LAB_TEST,
				label: "Lab Test",
				resource: WATCHMEN_RESOURCES.PATIENT_LAB_TEST,
				icon: <BiotechOutlinedIcon />,
			},
			{
				id: "glp",
				url: ROUTE_NAMES.GLP_1_PROGRAM,
				label: "GLP 1 Program",
				resource: WATCHMEN_RESOURCES.PATIENT_LAB_TEST,
				icon: <FaSyringe />,
			},
			{
				id: "vitals",
				url: ROUTE_NAMES.VITALS,
				label: "Vitals",
				resource: WATCHMEN_RESOURCES.PATIENT_VITALS,
				icon: <MonitorHeartOutlinedIcon />,
			},
			{
				id: "goals",
				url: ROUTE_NAMES.GOALS,
				label: "Goals",
				resource: WATCHMEN_RESOURCES.PATIENT_GOALS,
				icon: <FlagCircleOutlinedIcon />,
			},
			{
				id: "documents",
				url: ROUTE_NAMES.DOCUMENTS,
				label: "Documents",
				resource: WATCHMEN_RESOURCES.PATIENT_DOCUMENT,
				icon: <SnippetFolderOutlinedIcon />,
			},
		],
	},
	{
		id: "patient-history",
		url: ROUTE_NAMES.PATIENT_HISTORY,
		label: "Patient History",
		resource: WATCHMEN_RESOURCES.PATIENT_HISTORY,
		icon: <PendingActionsOutlinedIcon />,
	},
	{
		id: "patient-notes",
		url: ROUTE_NAMES.PATIENT_NOTES,
		label: "Patient Notes",
		resource: WATCHMEN_RESOURCES.PATIENT_NOTES,
		icon: <TextSnippetOutlinedIcon />,
	},
]

export const getStartConsultationUrl = (consultation: IAppointment, isStartConsultationActionAllowed: boolean, isIncenterConsult?: boolean, isAgentPsychologist?: boolean): string => {
	if(consultation.status === ConsultationStatusConstant.MISSED || consultation.status === ConsultationStatusConstant.CUSTOMER_MISSED){
		return null
	}
	const isCoachConsult = consultation?.doctorType === ConsultDoctorType.LC || consultation?.doctorType === ConsultDoctorType.GLP_NURSE
	const psychologistTargetUrl = `/${ROUTE_NAMES.PATIENT_DETAILS}/${consultation.patient.curefitUserId}/${ROUTE_NAMES.CONSULTATION}/${consultation.id}/${ROUTE_NAMES.ONGOING_PSYCHOLOGIST_CONSULT}`
	const coachTargetUrl = `/${ROUTE_NAMES.PATIENT_DETAILS}/${consultation.patient.curefitUserId}/${ROUTE_NAMES.CONSULTATION}/${consultation.id}/${ROUTE_NAMES.ONGOING_COACH_CONSULT}`
	if (isAgentPsychologist) {
		return isStartConsultationActionAllowed
			? `${ROUTE_NAMES.PATIENT_DETAILS}/${consultation.patient.curefitUserId}/${ROUTE_NAMES.VERIFY_COACH_CONSULT}?target=${encodeURIComponent(psychologistTargetUrl)}`
			: null
	}
	if (isCoachConsult) {
		return isStartConsultationActionAllowed
			? `${ROUTE_NAMES.PATIENT_DETAILS}/${consultation.patient.curefitUserId}/${ROUTE_NAMES.VERIFY_COACH_CONSULT}?target=${encodeURIComponent(coachTargetUrl)}`
			: null
	}
	return isStartConsultationActionAllowed
		? `${ROUTE_NAMES.PATIENT_DETAILS}/${consultation.patient.curefitUserId}/${ROUTE_NAMES.CONSULTATION}/${consultation.id}/${ROUTE_NAMES.ONGOING_DOCTOR_CONSULT}`
		: null
}

export const getUrlQueryParams = (searchStr: string) => {
	return new URLSearchParams(searchStr.split("?")[1])
}
